//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OrientGeomBuilder.js";
import "../CAM/CAM.NcmAvoidancePointBuilder.js";
import "../CAM/CAM.NcmClearanceBuilder.js";
let d=[[[0,"LowerLimitPlane",1,"NXObject",0],[1,"TransferAvoidanceFromBuilder",0,"CAM.NcmAvoidancePointBuilder",0],[1,"TransferAvoidanceGohomeBuilder",0,"CAM.NcmAvoidancePointBuilder",0],[1,"TransferAvoidanceReturnBuilder",0,"CAM.NcmAvoidancePointBuilder",0],[1,"TransferAvoidanceStartBuilder",0,"CAM.NcmAvoidancePointBuilder",0],[1,"TransferClearanceBuilder",0,"CAM.NcmClearanceBuilder",0]],[[[],"GetLowerLimitMode",{R_:{lowerLimitMode:''}},0,0],[["lowerLimitMode"],"SetLowerLimitMode",{},1,0]],[]];
SPLM.CAM.MillOrientGeomBuilder = class extends SPLM.CAM.OrientGeomBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MillOrientGeomBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.MillOrientGeomBuilder.LowerLimitModes = Object.freeze({
    "None" : "None", "Plane" : "Plane"});

export default SPLM;